<div class="p-6 bg-slate-50 dark:bg-slate-900 min-h-screen font-['Lato',sans-serif]">
    <!-- Decisions on the table -->
    <section class="mb-5">
        <header class="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-4">
            <h2 class="text-[10.5px] font-[700] text-purple-700 uppercase tracking-[1.4px] m-0"><span
                    class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case">Decisions
                    on the Table</span></h2>
            <div class="flex items-center gap-3 flex-wrap justify-end">
                <app-date-picker [size]="'md'" (valueChange)="rangeValues($event)"
                    (dateRangeChange)="onDateRangeChange($event)" [showComparison]="true" [showGroupBy]="true"
                    [allowedGroupByUnits]="allowedGroupByUnits">
                </app-date-picker>
            </div>
        </header>

        <!-- Cards Container -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch relative">
            @if (isRetentionLoading()) { <app-individual-toaster></app-individual-toaster> }

            <!-- Card 1: Growth outpacing throughput -->
            <div
                class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border shadow-sm relative overflow-hidden flex flex-col h-full"
                [ngClass]="getSeverityColors($safeNavigationMigration(growthOutpacingThroughput()?.severity)).cardBorder">
                <div class="absolute top-0 left-0 w-1 h-full"
                    [style.background-color]="getSeverityColors($safeNavigationMigration(growthOutpacingThroughput()?.severity)).border"></div>
                <div class="flex items-center gap-2 mb-[11px]"
                    [style.color]="getSeverityColors($safeNavigationMigration(growthOutpacingThroughput()?.severity)).text">
                    <div class="w-2 h-2 rounded-full"
                        [style.background-color]="getSeverityColors($safeNavigationMigration(growthOutpacingThroughput()?.severity)).dot"></div>
                    <span class="text-[10.5px] font-[700] tracking-[0.7px] uppercase">Growth outpacing throughput</span>
                </div>
                <p class="text-[14.5px] font-[500] leading-[1.5] text-slate-800 dark:text-slate-200 mb-[5px] h-[44px]">
                    @if (growthOutpacingThroughput()) {
                    <span [innerHTML]="formatFindingHtml(growthOutpacingThroughput().text)"></span>
                    } @else if (!isRetentionLoading() && decisionFlagsError()) {
                    <span class="italic text-red-500">{{ decisionFlagsError() }}</span>
                    } @else {
                    <span class="italic text-slate-500">No data</span>
                    }
                </p>

                <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>

                <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
                <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">
                    {{ growthOutpacingThroughput()?.action || 'Audit onboarding-to-contract conversion now: business registrations is growing far faster than contract throughput can absorb.' }}
                </p>
            </div>

            <!-- Card 2: Verification backlog gate -->
            <div
                class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border shadow-sm relative overflow-hidden flex flex-col h-full"
                [ngClass]="getSeverityColors($safeNavigationMigration(verificationBacklog()?.severity)).cardBorder">
                <div class="absolute top-0 left-0 w-1 h-full"
                    [style.background-color]="getSeverityColors($safeNavigationMigration(verificationBacklog()?.severity)).border"></div>
                <div class="flex items-center gap-2 mb-[11px]"
                    [style.color]="getSeverityColors($safeNavigationMigration(verificationBacklog()?.severity)).text">
                    <div class="w-2 h-2 rounded-full"
                        [style.background-color]="getSeverityColors($safeNavigationMigration(verificationBacklog()?.severity)).dot"></div>
                    <span class="text-[10.5px] font-[700] tracking-[0.7px] uppercase">Verification backlog gate</span>
                </div>

                <p class="text-[14.5px] font-[500] leading-[1.5] text-slate-800 dark:text-slate-200 mb-[5px] h-[44px]">
                    @if (verificationBacklogText()) {
                    <span [innerHTML]="formatFindingHtml(verificationBacklogText())"></span>
                    } @else {
                    <span class="italic text-slate-500">No data</span>
                    }
                </p>
                <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>

                <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
                <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">
                    {{ verificationBacklog()?.action || 'Track verification as its own throughput metric with an SLA, not a side-effect of upload volume.' }}
                </p>
            </div>

            <!-- Card 3: Cancelled-contract attrition -->
            <div
                class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border shadow-sm relative overflow-hidden flex flex-col h-full"
                [ngClass]="getSeverityColors($safeNavigationMigration(cancelledContractAttrition()?.severity)).cardBorder">
                <div class="absolute top-0 left-0 w-1 h-full"
                    [style.background-color]="getSeverityColors($safeNavigationMigration(cancelledContractAttrition()?.severity)).border"></div>
                <div class="flex items-center gap-2 mb-[11px]"
                    [style.color]="getSeverityColors($safeNavigationMigration(cancelledContractAttrition()?.severity)).text">
                    <div class="w-2 h-2 rounded-full"
                        [style.background-color]="getSeverityColors($safeNavigationMigration(cancelledContractAttrition()?.severity)).dot"></div>
                    <span class="text-[10.5px] font-[700] tracking-[0.7px] uppercase">Cancelled-contract attrition</span>
                </div>

                <p class="text-[14.5px] font-[500] leading-[1.5] text-slate-800 dark:text-slate-200 mb-[5px] h-[44px]">
                    @if (cancelledContractAttrition()) {
                    <span [innerHTML]="formatFindingHtml(cancelledContractAttrition().text)"></span>
                    } @else {
                    <span class="italic text-slate-500">No data</span>
                    }
                </p>
                <div class="border-t border-dashed border-slate-200 dark:border-slate-700 my-3"></div>

                <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
                <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-0">
                    {{ cancelledContractAttrition()?.action || 'Add a cancellation-reason tag at the point of cancellation.' }}
                </p>
            </div>
        </div>

    </section>

    <!-- The platform journey — stage-by-stage -->
    <section class="mb-5">

        <!-- Section Title & Subtitle -->
        <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-5">
            <h3
                class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case">
                The Platform Journey: Stage-by-Stage</h3>
        </div>

        <div class="space-y-6">

            <!-- TOP CARD CONTAINER -->
            <div class="bg-white dark:bg-slate-800 rounded-xl p-4 shadow-sm border border-slate-100 dark:border-slate-700 relative">
                @if (isJourneyLoading()) { <app-individual-toaster></app-individual-toaster> }

                <!-- Stage Selector Tabs -->
                <div
                    class="inline-flex items-center gap-1 p-1 text-xs font-semibold mb-3 bg-slate-100 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-700 rounded-md">
                    <button type="button" (click)="setJourneyTab('debt')" class="px-3 py-1.5 rounded-md transition-colors"
                        [class.bg-purple-600]="activeJourneyTab() === 'debt'"
                        [class.text-white]="activeJourneyTab() === 'debt'"
                        [class.text-slate-800]="activeJourneyTab() !== 'debt'"
                        [class.dark:text-slate-200]="activeJourneyTab() !== 'debt'"
                        [class.hover:text-slate-900]="activeJourneyTab() !== 'debt'">Debt Recovery</button>
                    <button type="button" (click)="setJourneyTab('contract')" class="px-3 py-1.5 rounded-md transition-colors"
                        [class.bg-purple-600]="activeJourneyTab() === 'contract'"
                        [class.text-white]="activeJourneyTab() === 'contract'"
                        [class.text-slate-800]="activeJourneyTab() !== 'contract'"
                        [class.dark:text-slate-200]="activeJourneyTab() !== 'contract'"
                        [class.hover:text-slate-900]="activeJourneyTab() !== 'contract'">Contract
                        Lifecycle</button>
                </div>

                <!-- Flow Cards -->
                <div class="flex flex-nowrap items-stretch gap-2 md:gap-2.5 overflow-x-auto pb-1 md:overflow-visible">

                    <!-- Stage 1: Businesses Registered (shared root for both tabs) -->
                    <div
                        class="relative flex-none w-[200px] lg:w-[220px] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl px-3.5 py-3 shadow-sm flex flex-col justify-between gap-2 overflow-hidden">
                        <div>
                            <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Businesses Registered</h3>
                            <p class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400 mt-0.5">Platform root, every flow starts here</p>
                        </div>
                        <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-1">
                            {{ $safeNavigationMigration(activeJourneyFlow()?.root?.value) | number }}
                        </div>
                        <div class="flex items-end justify-between gap-2">
                            <div class="text-[11px] font-[500] flex items-center gap-1" [class]="trendColorClass($safeNavigationMigration(activeJourneyFlow()?.root?.delta_pct))">
                                <div class="w-1.5 h-1.5 rounded-full" [ngClass]="(activeJourneyFlow()?.root?.delta_pct ?? 0) >= 0 ? 'bg-emerald-500' : 'bg-red-500'"></div>
                                {{ trendArrow($safeNavigationMigration(activeJourneyFlow()?.root?.delta_pct)) }} {{ absDelta($safeNavigationMigration(activeJourneyFlow()?.root?.delta_pct)) | number:'1.1-1' }}%
                            </div>
                            @if (activeJourneyTab() === 'debt') {
                            <div class="text-right">
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ $safeNavigationMigration(activeJourneyFlow()?.root?.sub_metrics?.['with_accounts']) | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">With contracts · {{ $safeNavigationMigration(activeJourneyFlow()?.root?.sub_metrics?.['with_accounts_pct']) | number:'1.0-0' }}%</p>
                            </div>
                            } @else {
                            <div class="text-right">
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ $safeNavigationMigration(activeJourneyFlow()?.root?.sub_metrics?.['newly_enrolled']) | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Newly enrolled</p>
                            </div>
                            }
                        </div>
                    </div>

                    @if (activeJourneyTab() === 'debt') {
                    <!-- Arrow 1 -> 2 -->
                    <div class="hidden md:flex items-center justify-center shrink-0 text-slate-300 dark:text-slate-600 self-center px-0.5" aria-hidden="true">
                        <svg class="w-6 h-4" viewBox="0 0 24 16" fill="none" stroke="currentColor">
                            <circle cx="2.5" cy="8" r="2" fill="currentColor" />
                            <line x1="2.5" y1="8" x2="20" y2="8" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M15.5 4.5L20.5 8L15.5 11.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <!-- Stage 2: Accounts Added -->
                    @if (getJourneyStage('accounts_added'); as stage) {
                    <div
                        class="relative flex-1 min-w-[210px] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 border-t-[3px] border-t-slate-700 dark:border-t-slate-400 rounded-xl px-3.5 py-3 shadow-sm flex flex-col justify-between gap-2 overflow-hidden">
                        <div class="flex items-start justify-between gap-2">
                            <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Accounts Added</h3>
                            <div class="text-[11px] font-[500] flex items-center gap-1 shrink-0" [class]="trendColorClass(stage.delta_pct)">
                                <div class="w-1.5 h-1.5 rounded-full" [ngClass]="stage.delta_pct >= 0 ? 'bg-emerald-500' : 'bg-red-500'"></div>
                                {{ trendArrow(stage.delta_pct) }} {{ absDelta(stage.delta_pct) | number:'1.1-1' }}%
                            </div>
                        </div>
                        <div>
                            <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-1">{{ stage.value | number }}</div>
                            <div class="flex items-center gap-2">
                                <div class="flex-1 bg-slate-100 dark:bg-slate-700 h-1.5 rounded-full overflow-hidden">
                                    <div class="bg-slate-700 dark:bg-slate-400 h-full rounded-full" [style.width.%]="stage.pct_of_prev"></div>
                                </div>
                                <span class="text-[11px] text-slate-400 shrink-0 font-medium">{{ stage.pct_of_prev | number:'1.0-1' }}%</span>
                            </div>
                        </div>
                        <div class="flex items-end justify-between gap-2">
                            <div>
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ stage.sub_metrics['pending_verification'] | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Pending verification</p>
                            </div>
                            <div class="text-right">
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ stage.sub_metrics['processed'] | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Processed</p>
                            </div>
                        </div>
                    </div>
                    }

                    <!-- Arrow 2 -> 3 -->
                    <div class="hidden md:flex items-center justify-center shrink-0 text-slate-300 dark:text-slate-600 self-center px-0.5" aria-hidden="true">
                        <svg class="w-6 h-4" viewBox="0 0 24 16" fill="none" stroke="currentColor">
                            <circle cx="2.5" cy="8" r="2" fill="currentColor" />
                            <line x1="2.5" y1="8" x2="20" y2="8" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M15.5 4.5L20.5 8L15.5 11.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <!-- Stage 3: Notification -->
                    @if (getJourneyStage('notification'); as stage) {
                    <div
                        class="relative flex-1 min-w-[210px] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 border-t-[3px] border-t-purple-600 rounded-xl px-3.5 py-3 shadow-sm flex flex-col justify-between gap-2 overflow-hidden">
                        <div class="flex items-start justify-between gap-2">
                            <div class="flex flex-wrap items-center gap-1.5 min-w-0">
                                <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Notification</h3>
                                @if (largestDebtExposureStage() === 'notification') {
                                <span
                                    class="bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400 text-[9.5px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider">LARGEST
                                    DEBT EXPOSURE</span>
                                }
                            </div>
                            <div class="text-[11px] font-[500] flex items-center gap-1 shrink-0" [class]="trendColorClass(stage.delta_pct)">
                                <div class="w-1.5 h-1.5 rounded-full" [ngClass]="stage.delta_pct >= 0 ? 'bg-emerald-500' : 'bg-red-500'"></div>
                                {{ trendArrow(stage.delta_pct) }} {{ absDelta(stage.delta_pct) | number:'1.1-1' }}%
                            </div>
                        </div>
                        <div>
                            <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-1">{{ stage.value | number }}</div>
                            <div class="flex items-center gap-2">
                                <div class="flex-1 bg-slate-100 dark:bg-slate-700 h-1.5 rounded-full overflow-hidden">
                                    <div class="bg-purple-600 h-full rounded-full" [style.width.%]="stage.pct_of_prev"></div>
                                </div>
                                <span class="text-[11px] text-slate-400 shrink-0 font-medium">{{ stage.pct_of_prev | number:'1.0-1' }}%</span>
                            </div>
                        </div>
                        <div class="flex items-end justify-between gap-2">
                            <div>
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ formatCompactCurrency(stage.sub_metrics['debt_exposure']) }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Debt exposure</p>
                            </div>
                            <div class="text-right">
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ stage.sub_metrics['recuvery'] | number }} / {{ stage.sub_metrics['referred'] | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Recuvery / Referred</p>
                            </div>
                        </div>
                    </div>
                    }

                    <!-- Arrow 3 -> 4 -->
                    <div class="hidden md:flex items-center justify-center shrink-0 text-slate-300 dark:text-slate-600 self-center px-0.5" aria-hidden="true">
                        <svg class="w-6 h-4" viewBox="0 0 24 16" fill="none" stroke="currentColor">
                            <circle cx="2.5" cy="8" r="2" fill="currentColor" />
                            <line x1="2.5" y1="8" x2="20" y2="8" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M15.5 4.5L20.5 8L15.5 11.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <!-- Stage 4: Collection -->
                    @if (getJourneyStage('collection'); as stage) {
                    <div
                        class="flex-1 min-w-[210px] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 border-t-[3px] border-t-amber-500 rounded-xl px-3.5 py-3 shadow-sm flex flex-col justify-between gap-2 overflow-hidden">
                        <div class="flex items-start justify-between gap-2">
                            <div class="flex flex-wrap items-center gap-1.5 min-w-0">
                                <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Collection</h3>
                                @if (largestDebtExposureStage() === 'collection') {
                                <span
                                    class="bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400 text-[9.5px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider">LARGEST
                                    DEBT EXPOSURE</span>
                                }
                            </div>
                            <div class="text-[11px] font-[500] flex items-center gap-1 shrink-0" [class]="trendColorClass(stage.delta_pct)">
                                <div class="w-1.5 h-1.5 rounded-full" [ngClass]="stage.delta_pct >= 0 ? 'bg-emerald-500' : 'bg-red-500'"></div>
                                {{ trendArrow(stage.delta_pct) }} {{ absDelta(stage.delta_pct) | number:'1.1-1' }}%
                            </div>
                        </div>
                        <div>
                            <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-1">{{ stage.value | number }}</div>
                            <div class="flex items-center gap-2">
                                <div class="flex-1 bg-slate-100 dark:bg-slate-700 h-1.5 rounded-full overflow-hidden">
                                    <div class="bg-amber-500 h-full rounded-full" [style.width.%]="stage.pct_of_prev"></div>
                                </div>
                                <span class="text-[11px] text-slate-400 shrink-0 font-medium">{{ stage.pct_of_prev | number:'1.0-1' }}%</span>
                            </div>
                        </div>
                        <div class="flex items-end justify-between gap-2">
                            <div>
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ formatCompactCurrency(stage.sub_metrics['debt_in_collection']) }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Debt in collection</p>
                            </div>
                            <div class="text-right">
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ stage.sub_metrics['recuvery'] | number }} / {{ stage.sub_metrics['referred'] | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Recuvery / Referred</p>
                            </div>
                        </div>
                    </div>
                    }
                    } @else {
                    <!-- Arrow 1 -> 2 (Contract Lifecycle) -->
                    <div class="hidden md:flex items-center justify-center shrink-0 text-slate-300 dark:text-slate-600 self-center px-0.5" aria-hidden="true">
                        <svg class="w-6 h-4" viewBox="0 0 24 16" fill="none" stroke="currentColor">
                            <circle cx="2.5" cy="8" r="2" fill="currentColor" />
                            <line x1="2.5" y1="8" x2="20" y2="8" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M15.5 4.5L20.5 8L15.5 11.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <!-- Stage 5: Contract Created -->
                    @if (getJourneyStage('contract_created'); as stage) {
                    <div
                        class="relative flex-1 min-w-[210px] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 border-t-[3px] border-t-teal-500 rounded-xl px-3.5 py-3 shadow-sm flex flex-col justify-between gap-2 overflow-hidden">
                        <div class="flex items-start justify-between gap-2">
                            <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Contract Created</h3>
                            <div class="text-[11px] font-[500] flex items-center gap-1 shrink-0" [class]="trendColorClass(stage.delta_pct)">
                                <div class="w-1.5 h-1.5 rounded-full" [ngClass]="stage.delta_pct >= 0 ? 'bg-emerald-500' : 'bg-red-500'"></div>
                                {{ trendArrow(stage.delta_pct) }} {{ absDelta(stage.delta_pct) | number:'1.1-1' }}%
                            </div>
                        </div>
                        <div>
                            <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-1">{{ stage.value | number }}</div>
                            <div class="flex items-center gap-2">
                                <div class="flex-1 bg-slate-100 dark:bg-slate-700 h-1.5 rounded-full overflow-hidden">
                                    <div class="bg-teal-500 h-full rounded-full" [style.width.%]="stage.pct_of_prev"></div>
                                </div>
                                <span class="text-[11px] text-slate-400 shrink-0 font-medium">{{ stage.pct_of_prev | number:'1.0-1' }}%</span>
                            </div>
                        </div>
                        <div class="flex items-end justify-between gap-2">
                            <div>
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ stage.sub_metrics['businesses_covered'] | number }} / {{ stage.sub_metrics['businesses_registered'] | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Businesses covered</p>
                            </div>
                            <div class="text-right">
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ $safeNavigationMigration(activeJourneyFlow()?.contracts_per_business) | number:'1.1-1' }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Contracts / business</p>
                            </div>
                        </div>
                    </div>
                    }

                    <!-- Arrow 2 -> 3 (Contract Lifecycle) -->
                    <div class="hidden md:flex items-center justify-center shrink-0 text-slate-300 dark:text-slate-600 self-center px-0.5" aria-hidden="true">
                        <svg class="w-6 h-4" viewBox="0 0 24 16" fill="none" stroke="currentColor">
                            <circle cx="2.5" cy="8" r="2" fill="currentColor" />
                            <line x1="2.5" y1="8" x2="20" y2="8" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M15.5 4.5L20.5 8L15.5 11.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <!-- Stage 6: Active -->
                    @if (getJourneyStage('active'); as stage) {
                    <div
                        class="relative flex-1 min-w-[210px] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 border-t-[3px] border-t-emerald-500 rounded-xl px-3.5 py-3 shadow-sm flex flex-col justify-between gap-2 overflow-hidden">
                        <div class="flex items-start justify-between gap-2">
                            <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Active</h3>
                            <div class="text-[11px] font-[500] flex items-center gap-1 shrink-0" [class]="trendColorClass(stage.delta_pct)">
                                <div class="w-1.5 h-1.5 rounded-full" [ngClass]="stage.delta_pct >= 0 ? 'bg-emerald-500' : 'bg-red-500'"></div>
                                {{ trendArrow(stage.delta_pct) }} {{ absDelta(stage.delta_pct) | number:'1.1-1' }}%
                            </div>
                        </div>
                        <div>
                            <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-1">{{ stage.value | number }}</div>
                            <div class="flex items-center gap-2">
                                <div class="flex-1 bg-slate-100 dark:bg-slate-700 h-1.5 rounded-full overflow-hidden">
                                    <div class="bg-emerald-500 h-full rounded-full" [style.width.%]="stage.pct_of_prev"></div>
                                </div>
                                <span class="text-[11px] text-slate-400 shrink-0 font-medium">{{ stage.pct_of_prev | number:'1.0-1' }}%</span>
                            </div>
                        </div>
                        <div class="flex items-end justify-between gap-2">
                            <div>
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ stage.value | number }} / {{ stage.sub_metrics['of_contracts'] | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Of contracts</p>
                            </div>
                            <div class="text-right">
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">Active</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">In good standing</p>
                            </div>
                        </div>
                    </div>
                    }

                    <!-- Arrow 3 -> 4 (Contract Lifecycle) -->
                    <div class="hidden md:flex items-center justify-center shrink-0 text-slate-300 dark:text-slate-600 self-center px-0.5" aria-hidden="true">
                        <svg class="w-6 h-4" viewBox="0 0 24 16" fill="none" stroke="currentColor">
                            <circle cx="2.5" cy="8" r="2" fill="currentColor" />
                            <line x1="2.5" y1="8" x2="20" y2="8" stroke-width="1.5" stroke-linecap="round" />
                            <path d="M15.5 4.5L20.5 8L15.5 11.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>

                    <!-- Stage 7: Overdue Needs attention -->
                    @if (getJourneyStage('overdue'); as stage) {
                    <div
                        class="flex-1 min-w-[210px] bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 border-t-[3px] border-t-red-500 rounded-xl px-3.5 py-3 shadow-sm flex flex-col justify-between gap-2 overflow-hidden">
                        <div class="flex items-start justify-between gap-2">
                            <div class="flex flex-wrap items-center gap-1.5 min-w-0">
                                <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Overdue</h3>
                                <span
                                    class="bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 text-[9.5px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider">NEEDS
                                    ATTENTION</span>
                            </div>
                            <div class="text-[11px] font-[500] flex items-center gap-1 shrink-0" [class]="trendColorClass(-stage.delta_pct)">
                                <div class="w-1.5 h-1.5 rounded-full" [ngClass]="stage.delta_pct <= 0 ? 'bg-emerald-500' : 'bg-red-500'"></div>
                                {{ trendArrow(stage.delta_pct) }} {{ absDelta(stage.delta_pct) | number:'1.1-1' }}%
                            </div>
                        </div>
                        <div>
                            <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-1">{{ stage.value | number }}</div>
                            <div class="flex items-center gap-2">
                                <div class="flex-1 bg-slate-100 dark:bg-slate-700 h-1.5 rounded-full overflow-hidden">
                                    <div class="bg-red-500 h-full rounded-full" [style.width.%]="stage.pct_of_prev"></div>
                                </div>
                                <span class="text-[11px] text-slate-400 shrink-0 font-medium">{{ stage.pct_of_prev | number:'1.0-1' }}%</span>
                            </div>
                        </div>
                        <div class="flex items-end justify-between gap-2">
                            <div>
                                <span class="text-xs font-bold text-slate-800 dark:text-slate-200">{{ stage.value | number }} / {{ stage.sub_metrics['of_contracts'] | number }}</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Of contracts</p>
                            </div>
                            <div class="text-right">
                                <span class="text-xs font-bold text-red-600 dark:text-red-400">Overdue</span>
                                <p class="text-[11px] text-slate-500 dark:text-slate-400 leading-tight">Past due date</p>
                            </div>
                        </div>
                    </div>
                    }
                    }

                </div>
            </div>

            <!-- BOTTOM CARD CONTAINER: RECOVERY CONVERSION & VALUE LEAK -->
            <div class="relative bg-white dark:bg-slate-800 rounded-xl p-[18px] shadow-sm border border-slate-100 dark:border-slate-700 space-y-6">
                @if (isConversionFunnelLoading()) { <app-individual-toaster></app-individual-toaster> }

                <!-- Section Header -->
                <div>
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Recovery Conversion & Value
                        Leak</h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">
                        Cumulative, on one shared 0–100% scale: solid advances to the next stage, hatched is the value
                        lost at that stage
                    </p>
                </div>

                <!-- Funnel Chart Rows -->
                @if (recoveryFunnelRows().length) {
                <div class="space-y-6">
                    @for (row of recoveryFunnelRows(); track row.key) {
                    <div>
                        <div class="flex justify-between items-baseline mb-1">
                            <div class="text-[12.5px]">
                                <span class="font-semibold text-slate-900 dark:text-white">{{ row.name }}</span>
                                <span class="text-[11px] text-slate-400 dark:text-slate-500 ml-2">{{ recoveryFunnelSubLabel(row.key) }}</span>
                            </div>
                            <div class="text-[12.5px]">
                                <span class="font-semibold text-slate-900 dark:text-white">{{ row.count | number }}</span>
                                <span class="text-[11px] text-slate-400 dark:text-slate-500 ml-1.5">{{ formatCompactCurrency(row.amount) }} · {{ row.pct_of_total | number:'1.0-1' }}%</span>
                            </div>
                        </div>
                        <div class="relative">
                            <div class="w-full h-3 bg-slate-50 dark:bg-slate-700/50 flex rounded-sm overflow-hidden">
                                <div [class]="recoveryFunnelBarColor(row.key)" class="h-full"
                                    [style.width.%]="row.solidWidth"
                                    (mouseenter)="!row.isLast && setHoveredFunnelSegment(row.key, 'solid')"
                                    (mouseleave)="clearHoveredFunnelSegment()"></div>
                                @if (!row.isLast) {
                                <div class="hatched-loss h-full" [style.width.%]="row.hatchedWidth"
                                    (mouseenter)="setHoveredFunnelSegment(row.key, 'hatched')"
                                    (mouseleave)="clearHoveredFunnelSegment()"></div>
                                }
                            </div>

                            <!-- Hover tooltip: solid segment -->
                            @if (!row.isLast && hoveredFunnelSegment()?.rowKey === row.key && hoveredFunnelSegment()?.type === 'solid') {
                            <div class="absolute bottom-full mb-2 -translate-x-1/2 z-50 min-w-[210px] bg-white dark:bg-slate-800 p-3 rounded-xl shadow-2xl border border-slate-100 dark:border-slate-700 pointer-events-none whitespace-nowrap"
                                [style.left.%]="row.solidTooltipLeft">
                                <div class="flex items-center justify-between gap-4">
                                    <div class="flex items-center gap-2">
                                        <span class="w-2.5 h-2.5 rounded-sm shrink-0" [class]="recoveryFunnelBarColor(row.key)"></span>
                                        <span class="text-[12.5px] font-semibold text-slate-800 dark:text-slate-200">Advances to {{ row.nextLabel }}</span>
                                    </div>
                                    <span class="text-[12.5px] font-semibold text-slate-900 dark:text-white">{{ row.nextCount | number }}</span>
                                </div>
                                <div class="text-[11px] text-slate-500 dark:text-slate-400 font-medium mt-1 pl-4.5">{{ row.nextPct | number:'1.0-1' }}% of the book carried forward</div>
                            </div>
                            }

                            <!-- Hover tooltip: hatched (leak) segment -->
                            @if (!row.isLast && hoveredFunnelSegment()?.rowKey === row.key && hoveredFunnelSegment()?.type === 'hatched') {
                            <div class="absolute bottom-full mb-2 -translate-x-1/2 z-50 min-w-[210px] bg-white dark:bg-slate-800 p-3 rounded-xl shadow-2xl border border-slate-100 dark:border-slate-700 pointer-events-none whitespace-nowrap"
                                [style.left.%]="row.hatchedTooltipLeft">
                                <div class="flex items-center justify-between gap-4">
                                    <div class="flex items-center gap-2">
                                        <span class="w-2.5 h-2.5 rounded-sm shrink-0 bg-red-500"></span>
                                        <span class="text-[12.5px] font-semibold text-slate-800 dark:text-slate-200">{{ row.leakTitle }}</span>
                                    </div>
                                    <span class="text-[12.5px] font-semibold text-red-600 dark:text-red-400">-{{ row.leak_count | number }}</span>
                                </div>
                                <div class="text-[11px] text-slate-500 dark:text-slate-400 font-medium mt-1 pl-4.5">{{ formatCompactCurrency(row.leak_amount) }}{{ row.leakSuffix ? ' · ' + row.leakSuffix : '' }}</div>
                            </div>
                            }
                        </div>
                        @if (!row.isLast) {
                        <p class="text-[11px] text-red-600 font-medium mt-1">
                            ↓ -{{ row.leak_count | number }} · {{ formatCompactCurrency(row.leak_amount) }} <span class="font-normal text-red-600">{{ row.leak_note }}</span>
                        </p>
                        }
                    </div>
                    }
                </div>
                } @else if (!isConversionFunnelLoading()) {
                <div class="flex flex-col items-center justify-center py-8 text-slate-400">
                    <p class="text-sm">No data available</p>
                </div>
                }
            </div>
        </div>

    </section>
    <!-- Business adoption & contract pipeline -->
    <section class="mb-5">

        <h3
            class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white normal-case mb-5">
            Enrollment & Activation</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 relative">
            @if (isChartsLoading()) { <app-individual-toaster></app-individual-toaster> }
            <!-- Businesses Enrolled KPI -->
            <div
                class="bg-gradient-to-r from-purple-50/50 to-white dark:from-purple-900/20 dark:to-slate-800 rounded-lg p-4 shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
                <div class="flex justify-between items-start mb-2">
                    <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Businesses Enrolled</h3>
                    <span class="text-[9.5px] font-bold px-2 py-1 rounded-full uppercase tracking-wider"
                        [ngClass]="enrolledBusinessesSignal().mom > 0 ? 'bg-slate-100 text-slate-600 dark:bg-slate-700/60 dark:text-slate-300' : enrolledBusinessesSignal().mom < 0 ? 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300' : 'bg-emerald-100 text-emerald-500 dark:bg-emerald-900/30 dark:text-emerald-400'">{{
                        enrolledBusinessesSignal().mom > 0 ?
                        'LEADING' : enrolledBusinessesSignal().mom == 0 ? 'STABLE' : 'LAGGING' }}</span>
                </div>
                <div
                    class="font-['Lato',sans-serif] text-[26px] font-bold leading-none tracking-[-1px] text-slate-900 dark:text-white mb-1">
                    {{ enrolledBusinessesSignal().value | number }}</div>
                <div class="text-[11px] flex items-center gap-1 font-medium mt-4"
                    [ngClass]="enrolledBusinessesSignal().mom > 0 ? 'text-emerald-600' : enrolledBusinessesSignal().mom < 0 ? 'text-red-600' : 'text-orange-500'">
                    <div class="w-1.5 h-1.5 rounded-full"
                        [ngClass]="enrolledBusinessesSignal().mom > 0 ? 'bg-emerald-600' : enrolledBusinessesSignal().mom < 0 ? 'bg-red-600' : 'bg-orange-500'">
                    </div>
                    {{ enrolledBusinessesSignal().mom > 0 ? '+' : '' }}{{ enrolledBusinessesSignal().mom | number:'1.2-2' }}% {{ comparisonLabel }}
                </div>
            </div>

            <!-- Businesses with a Contract KPI -->
            <div
                class="bg-gradient-to-r from-purple-50/80 to-white dark:from-purple-900/30 dark:to-slate-800 rounded-lg p-4 shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden">
                <!-- Gradient Left Border -->
                <div class="absolute top-0 left-0 bottom-0 w-1 bg-gradient-to-b from-[#9333EA] to-[#3B82F6]"></div>

                <div class="flex justify-between items-start mb-2">
                    <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Businesses With a Contract</h3>
                    <span
                        class="text-[10px] font-bold uppercase tracking-wider bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 px-2 py-0.5 rounded">ACTIVATION</span>
                </div>
                <div
                    class="font-['Lato',sans-serif] text-[26px] font-bold leading-none tracking-[-1px] text-slate-900 dark:text-white mb-1">
                    {{ businessesWithContractSignal().value | number }}</div>
                <div class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400 mb-3">
                    Of {{ enrolledBusinessesSignal().value | number }} enrolled · {{ businessesWithContractSignal().toConvert | number }} have no contract yet
                </div>

                <!-- Progress bar -->
                <div class="w-full bg-slate-100 dark:bg-slate-700 rounded-full h-1.5">
                    <div class="bg-gradient-to-r from-[#9333EA] to-[#3B82F6] h-1.5 rounded-full"
                        [style.width.%]="businessesWithContractSignal().goalPct"></div>
                </div>
            </div>
        </div>

        <!-- Charts Section -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 relative">
            @if (isChartsLoading()) { <app-individual-toaster></app-individual-toaster> }
            <!-- Chart 1: Trend — Enrolled & Contracts Created -->
            <div
                class="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 p-[18px] flex flex-col">
                <div class="mb-4">
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Enrolled Businesses &
                        Contracts Created
                    </h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Business adoption
                        (left axis) tracking against contract volume (right axis) · follows the selected date range and
                        grouping</p>
                </div>
                <div class="w-full h-[220px]">
                    @if (chart1Data().length) {
                    <div class="w-full h-full relative overflow-x-auto overflow-y-hidden custom-scrollbar">
                        <div [style.min-width.px]="getAllTimeChartMinWidth(chart1Data().length)" class="h-full w-full">
                            <app-bar-line [data1]="chart1Data()" [lines]="chart1Lines" [legendData]="chart1Legend"
                                [colors]="chart1Colors" [tooltipData]="chart1Tooltip" [valueKey]="'enrolled'"
                                [valueType]="''" [rightAxisType]="'number'" [leftAxisLabel]="'Enrolled'"
                                [rightAxisLabel]="'Active Businesses'" [rightAxisLabelOffset]="35"
                                [margin]="{ top: 20, right: 50, bottom: 40, left: 65 }" [labelKey]="'start'"
                                [showBackground]="false" [barTextposition]="'none'" [formatDateXAxis]="false"
                                [unit]="unit()" [xAxisShowOnlyFirstLast]="true" [formatKM]="false">
                            </app-bar-line>
                        </div>
                    </div>
                    } @else {
                    <div class="flex flex-col items-center justify-center h-full text-slate-400">
                        <p class="text-sm">No data available</p>
                    </div>
                    }
                </div>
            </div>

            <!-- Chart 2: Recuvery Demo — booking status -->
            <div
                class="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 p-[18px] flex flex-col">
                <div class="mb-4">
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Recuvery Demo: Booking Status
                    </h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">The single onboarding
                        training every business goes through · {{ bookingStatusTotal() | number }} demo bookings tracked</p>
                </div>
                <div class="w-full h-[220px]">
                    @if (bookingStatusList().length) {
                    <div class="w-full h-full overflow-y-auto custom-scrollbar flex flex-col justify-center gap-3 pr-1">
                        @for (status of bookingStatusList(); track status.name) {
                        <div class="flex items-center gap-3">
                            <span class="w-[140px] shrink-0 text-xs font-medium truncate" [style.color]="status.color">{{ status.name }}</span>
                            <div class="flex-1 h-1.5 bg-slate-100 dark:bg-slate-700 rounded-full overflow-hidden">
                                <div class="h-full rounded-full" [style.width.%]="status.pct" [style.background-color]="status.color"></div>
                            </div>
                            <span class="w-8 shrink-0 text-right text-xs font-semibold text-slate-700 dark:text-slate-300">{{ status.count | number }}</span>
                        </div>
                        }
                    </div>
                    } @else if (!isChartsLoading()) {
                    <div class="flex flex-col items-center justify-center h-full text-slate-400">
                        <p class="text-sm">No data available</p>
                    </div>
                    }
                </div>
            </div>
        </div>
    </section>
    <!-- Industry mix -->
    <section class="mb-5">
        <h3
            class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white normal-case mb-5">
            Industry mix</h3>

        <!-- Industry Top Categories & Risk Quadrant -->
        <div class="grid grid-cols-1 xl:grid-cols-2 gap-6 relative">
            @if (isIndustryLoading()) { <app-individual-toaster fontSize="16px" /> }
            <!-- Top Categories Bar Chart -->
            <div
                class="bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 p-[18px] shadow-sm relative overflow-hidden flex flex-col justify-between min-h-[340px]">
                <div class="mb-2">
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Top Categories By Contracts
                    </h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Recovery
                        workload by industry
                        @if (topIndustrySummary().length) {
                        · {{ topIndustrySummary().join(' + ') }} carry the largest pool
                        }
                    </p>
                </div>

                <div class="w-full flex-1 min-h-[220px]">
                    @if (topCategoriesData().length > 0) {
                    <app-bar-line [data1]="topCategoriesData()" [colors]="categoryChartColors"
                        [tooltipData]="categoryChartTooltip" [labelKey]="'category'" [tooltipHeaderKey]="'fullCategory'"
                        [valueKey]="'data1'" [showBackground]="false" [barTextposition]="'none'" [wrapXAxisLabels]="true"
                        [margin]="{ top: 10, right: 10, bottom: 44, left: 35 }" [valueType]="''">
                    </app-bar-line>
                    } @else {
                    <div class="flex items-center justify-center h-full text-slate-400 text-sm">No data available</div>
                    }
                </div>
            </div>

            <!-- Risk Quadrant -->
            <div
                class="bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 p-[18px] shadow-sm relative overflow-hidden flex flex-col">
                <div class="mb-4">
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Industry Risk Quadrant</h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Unit profit
                        against
                        overdue
                        risk · credit & sales decisions</p>
                </div>

                <!-- Quadrant Grid Container -->
                <div class="relative flex-grow flex flex-col pt-1 pl-8 pb-8 pr-1">

                    <!-- Axis Labels -->
                    <div class="absolute left-0 top-1/2 -translate-y-1/2 w-8 h-full flex items-center justify-center">
                        <div
                            class="origin-center -rotate-90 whitespace-nowrap text-[10px] font-bold uppercase tracking-widest text-slate-500 flex items-center gap-1">
                            HIGHER UNIT PROFIT <span class="text-lg leading-none">→</span>
                        </div>
                    </div>
                    <div
                        class="absolute bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10px] font-bold uppercase tracking-widest text-slate-500 flex items-center gap-1">
                        HIGHER OVERDUE RISK <span class="text-lg leading-none">→</span>
                    </div>

                    <!-- The 2x2 Grid -->
                    <div class="grid grid-cols-2 grid-rows-2 gap-2 w-full h-full">

                        <!-- Q1: High Profit, Low Risk (Top Left) -->
                        <div
                            class="bg-[#e6f6ec] dark:bg-emerald-900/20 border border-[#c7e8d1] dark:border-emerald-800/30 rounded-lg p-3 h-[120px] flex flex-col">
                            <div class="flex items-center justify-between">
                                <div
                                    class="text-emerald-700 dark:text-emerald-400 text-[11px] font-bold mb-1.5 flex items-center gap-1">
                                    ✓ High profit · Low risk
                                </div>
                                <span
                                    class="text-[14px] font-[600] ml-2 text-right text-emerald-700 dark:text-emerald-400">({{riskQuadrantData().q1.length}})</span>
                            </div>
                            <div class="flex-grow overflow-hidden flex flex-col gap-1">
                                @for (item of riskQuadrantData().q1; track item.name) {
                                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                                    {{item.name}} (${{item.profit | number:'1.0-0'}})
                                    <!-- , {{item.risk | number:'1.0-0'}} -->
                                </div>
                                }
                                @if (!riskQuadrantData().q1.length) { <p
                                    class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data
                                    available</p> }
                            </div>
                        </div>

                        <!-- Q2: High Profit, High Risk (Top Right) -->
                        <div
                            class="bg-[#fbe7e7] dark:bg-red-900/20 border border-[#f3cccc] dark:border-red-800/30 rounded-lg p-3 h-[120px] flex flex-col">
                            <div class="flex items-center justify-between">
                                <div
                                    class="text-red-700 dark:text-red-400 text-[11px] font-bold mb-1.6 flex items-center gap-1">
                                    ⚠ High profit · High risk
                                </div>
                                <span
                                    class="text-[14px] font-[600] ml-2 text-right text-red-700 dark:text-red-400">({{riskQuadrantData().q2.length}})</span>
                            </div>
                            <div class="flex-grow overflow-hidden flex flex-col gap-1">
                                @for (item of riskQuadrantData().q2; track item.name) {
                                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                                    {{item.name}} (${{item.profit | number:'1.0-0'}})
                                </div>
                                }
                                @if (!riskQuadrantData().q2.length) { <p
                                    class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data
                                    available</p> }
                            </div>
                        </div>

                        <!-- Q3: Moderate Profit, Med Risk (Bottom Left) -->
                        <div
                            class="bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800/30 rounded-lg p-3 h-[120px] flex flex-col">
                            <div class="flex items-center justify-between">
                                <div
                                    class="text-purple-700 dark:text-purple-400 text-[11px] font-bold mb-1.5 flex items-center gap-1">
                                    ● Moderate · Med risk
                                </div>
                                <span
                                    class="text-[14px] font-[600] ml-2 text-right text-purple-700 dark:text-purple-400">({{riskQuadrantData().q3.length}})</span>
                            </div>
                            <div class="flex-grow overflow-hidden flex flex-col gap-1">
                                @for (item of riskQuadrantData().q3; track item.name) {
                                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                                    {{item.name}} (${{item.profit | number:'1.0-0'}})
                                </div>
                                }
                                @if (!riskQuadrantData().q3.length) { <p
                                    class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data
                                    available</p> }
                            </div>
                        </div>

                        <!-- Q4: Low Profit, High Risk (Bottom Right) -->
                        <div
                            class="bg-orange-50 dark:bg-orange-900/20 border border-orange-100 dark:border-orange-800/30 rounded-lg p-3 h-[120px] flex flex-col">
                            <div class="flex items-center justify-between">
                                <div
                                    class="text-orange-700 dark:text-orange-400 text-[11px] font-bold mb-1.5 flex items-center gap-1">
                                    X High overdue risk
                                </div>
                                <span
                                    class="text-[14px] font-[600] ml-2 text-right text-orange-700 dark:text-orange-400">({{riskQuadrantData().q4.length}})</span>
                            </div>
                            <div class="flex-grow overflow-hidden flex flex-col gap-1">
                                @for (item of riskQuadrantData().q4; track item.name) {
                                <div class="text-[11px] text-slate-600 dark:text-slate-300 truncate">
                                    {{item.name}} (${{item.profit | number:'1.0-0'}})
                                </div>
                                }
                                @if (!riskQuadrantData().q4.length) { <p
                                    class="text-[12.5px] text-slate-600 dark:text-slate-400 font-medium mt-4">No data
                                    available</p> }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </section>
    <!-- ─────────────── Geographic distribution ───────────────────────────────────── -->
    <section class="mb-5">
        <h3
            class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white normal-case mb-5">
            Geographic distribution</h3>

        <!-- Cards -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 relative">
            @if (isLicensingLoading()) { <app-individual-toaster></app-individual-toaster> }
            @if (!isLicensingLoading() && stateLicensingStatsError()) {
            <div class="md:col-span-2 py-4 text-center text-red-500 text-sm">
                {{ stateLicensingStatsError() }}
            </div>
            } @else {
            <!-- Accounts in States Allowed -->
            <div
                class="bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 p-4 shadow-sm relative overflow-hidden">
                <div class="flex items-start justify-between mb-2 relative z-10">
                    <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Accounts in States Allowed</h3>
                    <span
                        class="text-[9.5px] font-bold uppercase tracking-wider bg-slate-100 text-slate-600 dark:bg-slate-700/60 dark:text-slate-300 px-2 py-1 rounded-full">Allowed</span>
                </div>
                <div
                    class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2 tabular-nums relative z-10">
                    {{ stateLicensingStats().allowed_count | number }}
                </div>
                <p class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400 relative z-10 mb-0">
                    Licensed jurisdictions ({{ stateLicensingStats().allowed_states_n }} states) · {{
                    stateLicensingStats().allowed_pct | number:'1.0-1' }}% of portfolio book · Active collections
                    sequence
                </p>
            </div>

            <!-- Accounts in States Not Allowed -->
            <div
                class="bg-gradient-to-r from-red-50 to-white dark:from-red-900/20 dark:to-slate-800 border border-red-100 dark:border-red-900/30 border-l-[3px] border-l-red-600 rounded-xl p-4 shadow-sm relative overflow-hidden">
                <div class="flex items-start justify-between mb-2 relative z-10">
                    <h3 class="text-[11px] font-[600] text-[#6a7c93] uppercase">Accounts in States Not Allowed</h3>
                    <span
                        class="text-[9.5px] font-bold uppercase tracking-wider bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400 px-2 py-1 rounded-full">Restricted</span>
                </div>
                <div
                    class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2 tabular-nums flex items-center gap-2 relative z-10">
                    {{ stateLicensingStats().not_allowed_count | number }}
                </div>
                <p class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400 relative z-10 mb-0">
                    Licensing pending ({{ stateLicensingStats().not_allowed_states_n }} states) · {{
                    stateLicensingStats().not_allowed_pct | number:'1.0-1' }}% of portfolio book · Collection
                    activities paused
                </p>
            </div>
            }
        </div>
        <!-- state mix -->
        <div class="grid grid-cols-1 md:grid-cols-12 gap-4 items-stretch mb-4 relative">
            @if (isChartsLoading()) { <app-individual-toaster></app-individual-toaster> }
            <div class="md:col-span-7 flex flex-col gap-4 relative overflow-hidden">
                <div
                    class="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 p-[18px] flex flex-col flex-1 relative overflow-hidden">
                    <div class="mb-3">
                        <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">State Mix: Outreach Vs.
                            Portfolio
                        </h4>
                        <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Proposals sent and
                            active debt accounts, by state: two independent measures</p>
                    </div>
                    <div class="w-full flex-1 flex flex-col justify-center min-h-[220px]">
                        @if (proposalConversionChartData().length) {
                        <app-horizontal-bar-chart [data]="proposalConversionChartData()" [showXAxisGrid]="true"
                            [showXAxisLabel]="false" [showYAxisLine]="false" [colorYAxisLabels]="false" [barHeight]="22"
                            [barPadding]="0.25" [groupSize]="2" [groupGapSlots]="1" [roundedCorners]="true"
                            [cornerRadius]="6" [leftMargin]="100" [maxLabelWidth]="90" [yAxisTickPadding]="12"
                            [minHeight]="180" [marginBottom]="10" [legendOffset]="36" [valueType]="'number'"
                            [showBarsValue]="false" [showLegend]="true"
                            [legendItems]="[{label: 'Proposals Sent', color: '#0d9488'}, {label: 'Accounts in Recovery', color: '#7c3aed'}]"
                            class="w-full block">
                        </app-horizontal-bar-chart>
                        } @else if (isChartsLoading()) {
                        <div class="flex flex-col items-center justify-center h-full text-slate-400 py-12">
                            <p class="text-sm">Loading...</p>
                        </div>
                        } @else if (stateOutreachError()) {
                        <div class="flex flex-col items-center justify-center h-full text-red-500 py-12">
                            <p class="text-sm">{{ stateOutreachError() }}</p>
                        </div>
                        } @else {
                        <div class="flex flex-col items-center justify-center h-full text-slate-400 py-12">
                            <p class="text-sm">No data available</p>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="md:col-span-5 flex flex-col gap-4 relative overflow-hidden">
                <div
                    class="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 p-[18px] flex flex-col flex-1 relative overflow-hidden">
                    <div class="mb-3">
                        <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">State Rollup</h4>
                        <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Active debt accounts and
                            total recovered cash by state</p>
                    </div>
                    <div class="w-full flex-1 flex flex-col justify-center">
                        @if (stateRollupDisplay().length) {
                        <ul class="divide-y divide-slate-100 dark:divide-slate-700">
                            @for(item of stateRollupDisplay(); track item.name) {
                            <li class="flex items-center justify-between py-2">
                                <div>
                                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">
                                        {{item.name}}
                                    </h4>
                                    <p class="text-[11px] text-slate-500 dark:text-slate-400 font-normal">
                                        {{item.share | number:'1.1-1'}}% of book <span class="mx-0.5">·</span>
                                        {{item.accounts | number}} accounts <span class="mx-0.5">·</span>
                                        {{item.rate | number:'1.1-1'}}% recovery rate
                                    </p>
                                </div>
                                <div class="text-right">
                                    <span class="block text-[18px] font-[600] {{item.colorClass}}">{{item.recovered_amt
                                        | currency}}</span>
                                    <span
                                        class="block text-[11px] text-slate-500 dark:text-slate-400 font-normal">recovered</span>
                                </div>
                            </li>
                            }
                        </ul>
                        } @else if (isRevenueLoading()) {
                        <div class="py-8 text-center text-slate-400 text-sm">Loading...</div>
                        } @else if (stateRollupError()) {
                        <div class="py-8 text-center text-red-500 text-sm">{{ stateRollupError() }}</div>
                        } @else {
                        <div class="py-8 text-center text-slate-400 text-sm">No data available</div>
                        }
                    </div>
                </div>
            </div>
        </div>
        <!-- Map Section -->
        <div
            class="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 p-[18px] flex flex-col relative overflow-hidden">
            @if (isGeoLoading()) { <app-individual-toaster></app-individual-toaster> }

            <div class="flex flex-col md:flex-row md:justify-between md:items-start mb-6 relative z-10 gap-4">
                <div>
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Geographic Distribution</h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4]">Live state
                        metrics &middot; click any region for a market
                        deep-dive</p>
                </div>

                <div class="flex items-center gap-2 self-start md:self-auto pt-1">
                    <span class="w-2 h-2 rounded-full bg-purple-600"></span>
                    <span class="text-xs font-semibold text-slate-700 dark:text-slate-300">Current: <span
                            class="font-bold text-slate-900 dark:text-white">{{ currentMapTotal() | number
                            }}</span></span>
                </div>
            </div>

            <div class="flex flex-wrap items-center gap-6 mb-6 relative z-10">
                <!-- Metric Toggle -->
                <div class="flex flex-col items-start gap-1.5">
                    <span class="text-[10px] font-bold uppercase tracking-widest text-slate-500">Metric</span>
                    <div
                        class="inline-flex items-center gap-1 p-1 bg-slate-100 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-700 rounded-md">
                        <button (click)="setGeoMetricMode('biz')"
                            [class.bg-purple-600]="geoMetricMode() === 'biz'"
                            [class.text-white]="geoMetricMode() === 'biz'"
                            [class.text-slate-800]="geoMetricMode() !== 'biz'"
                            [class.dark:text-slate-200]="geoMetricMode() !== 'biz'"
                            class="px-3 py-1.5 rounded-md text-xs font-semibold transition-colors duration-200">Businesses</button>
                        <button (click)="setGeoMetricMode('con')"
                            [class.bg-purple-600]="geoMetricMode() === 'con'"
                            [class.text-white]="geoMetricMode() === 'con'"
                            [class.text-slate-800]="geoMetricMode() !== 'con'"
                            [class.dark:text-slate-200]="geoMetricMode() !== 'con'"
                            class="px-3 py-1.5 rounded-md text-xs font-semibold transition-colors duration-200">Contracts</button>
                    </div>
                </div>
            </div>

            <!-- Map -->
            <div
                class="w-full h-[400px] bg-slate-50 dark:bg-slate-900/20 rounded-xl overflow-hidden relative border border-slate-100 dark:border-slate-700/50">
                @if (mapData().length > 0) {
                <app-geographic-map class="block w-full h-full" [stateData]="mapData()" [valueKeys]="mapValueKeys()"
                    (regionClick)="onRegionClick($event)">
                </app-geographic-map>
                } @else if (isGeoLoading()) {
                <div class="flex flex-col items-center justify-center h-full text-slate-400">
                    <p class="text-sm">Loading map data...</p>
                </div>
                } @else if (mapDataError()) {
                <div class="flex flex-col items-center justify-center h-full text-red-500">
                    <p class="text-sm">{{ mapDataError() }}</p>
                </div>
                } @else {
                <div class="flex flex-col items-center justify-center h-full text-slate-400">
                    <p class="text-sm">No map data available</p>
                </div>
                }

                <div
                    class="absolute bottom-4 left-6 text-[10px] text-slate-500 font-medium bg-white/80 dark:bg-slate-800/80 px-2 py-1 rounded">
                    {{ mapData().length }} states - click any state for details
                </div>
            </div>
        </div>


    </section>
    <!-- Contract portfolio -->
    <section class="mb-10">
        <h3
            class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white normal-case mb-5">
            Contract portfolio</h3>

        <!-- Status Trends & State Summary Section -->
        <div class="grid grid-cols-1 xl:grid-cols-2 gap-6 relative">
            @if (isChartLoading() || isTableLoading()) { <app-individual-toaster></app-individual-toaster> }
            <!-- Chart Card -->
            <div
                class="bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 p-[18px] shadow-sm relative overflow-hidden flex flex-col min-h-[300px]">
                <div class="mb-3">
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white flex items-center gap-2">
                        Contract Status Trends
                    </h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4] mb-[13px] break-words">Contract status across all
                        stages {{ formattedDateRange }}
                    </p>
                </div>
                <div class="flex-grow w-full relative min-h-[230px] flex flex-col">
                    @if (contractStatusTrends().length > 0) {
                    <app-multi-stacked-bar-chart [data]="contractStatusTrends()" [legendData]="statusChartLegend"
                        [showLegend]="true" [showYAxis]="true" [showOnlyFirstLastXAxis]="true" [showXAxis]="true"
                        [tooltipShowAllSeries]="true">
                    </app-multi-stacked-bar-chart>
                    } @else if (isChartLoading()) {
                    <div class="absolute inset-0 flex items-center justify-center text-slate-400 text-sm">
                        Loading...
                    </div>
                    } @else if (contractStatusTrendsError()) {
                    <div class="absolute inset-0 flex items-center justify-center text-red-500 text-sm text-center px-4">
                        {{ contractStatusTrendsError() }}
                    </div>
                    } @else {
                    <div class="absolute inset-0 flex items-center justify-center text-slate-400 text-sm">
                        No data available
                    </div>
                    }
                </div>
            </div>

            <!-- Table Card -->
            <div
                class="bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 p-[18px] shadow-sm relative overflow-hidden flex flex-col min-h-[340px]">
                <div class="mb-3">
                    <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white flex items-center gap-2">
                        Account state summary
                    </h4>
                    <p class="text-[11.5px] text-[#6a7c93] dark:text-slate-400 mt-[3px] leading-[1.4] mb-[13px]">Verification, payment & dispute flags
                        across the {{contractStateHeadline() || 0}}-account book · Verified/Non-Verified partition the
                        book;
                        DND, Disputed & Pause
                        are overlapping flags
                    </p>
                </div>
                <div class="overflow-x-auto">
                    <table class="w-full text-left border-collapse">
                        <thead>
                            <tr class="border-b border-slate-200 dark:border-slate-700">
                                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
                                    State</th>
                                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
                                    Count</th>
                                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
                                    % of Book</th>
                                <th class="py-2 px-3 text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
                                    Signal</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of contractStateSummary(); track row.state; let i = $index) {
                            <tr
                                class="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-800/80 transition-colors">
                                <td class="py-2 px-3 text-[12.5px] text-slate-900 dark:text-white font-semibold">
                                    {{row.state}}</td>
                                <td class="py-2 px-3 text-[11px] text-slate-700 dark:text-slate-300 font-medium">{{row.count |
                                    number}}</td>
                                <td class="py-2 px-3 text-[11px] text-slate-700 dark:text-slate-300 font-medium">{{row.pct |
                                    number:'1.1-2'}}%</td>
                                <td class="py-2 px-3 text-[11px] font-semibold {{row.signal.colorClass}}">
                                    {{row.signal.text}}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                    @if (isTableLoading() && contractStateSummary().length === 0) {
                    <div class="py-8 text-center text-slate-400 text-sm">
                        Loading...
                    </div>
                    } @else if (!isTableLoading() && contractStateSummaryError()) {
                    <div class="py-8 text-center text-red-500 text-sm">
                        {{ contractStateSummaryError() }}
                    </div>
                    } @else if (!isTableLoading() && contractStateSummary().length === 0) {
                    <div class="py-8 text-center text-slate-400 text-sm">
                        No summary data available
                    </div>
                    }
                </div>
            </div>
        </div>

    </section>

</div>

<!-- Deep Dive Modal -->
@if (isDeepDiveModalOpen()) {
<div class="fixed inset-0 z-[9999] flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-slate-900/40 dark:bg-slate-900/60 backdrop-blur-sm" (click)="closeDeepDiveModal()">
    </div>

    <!-- Modal Content -->
    <div
        class="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-[800px] max-h-[90vh] overflow-hidden m-4 flex flex-col">
        <!-- Scrollable area — kept separate from the rounded outer shell so the scrollbar
             never sits flush against (and squares off) the rounded corners. -->
        <div class="min-h-0 flex-1 overflow-y-auto flex flex-col">
        <!-- Header -->
        <div
            class="px-6 py-5 border-b border-slate-100 dark:border-slate-700/50 flex items-start justify-between bg-slate-50/50 dark:bg-slate-800/50 rounded-t-2xl">
            <div>
                <div class="text-[9.5px] font-[700] tracking-[0.7px] text-purple-700 uppercase mb-1">
                    Market deep-dive @if (deepDiveData()) { · {{ deepDiveData().isBizMode ? 'businesses' : 'contracts' }} }
                </div>
                <h2 class="text-xl font-bold tracking-[-0.4px] text-slate-900 dark:text-white">
                    @if (deepDiveData()) { {{ deepDiveData().regionName }}, {{ deepDiveData().countryLabel }} }
                </h2>
            </div>
            <button (click)="closeDeepDiveModal()"
                class="w-8 h-8 flex items-center justify-center rounded-full bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 text-slate-500 hover:text-slate-900 hover:bg-slate-100 dark:hover:bg-slate-600 transition-colors">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 6 6 18" />
                    <path d="m6 6 12 12" />
                </svg>
            </button>
        </div>

        @if (isDeepDiveLoading()) {
        <div class="p-6 flex flex-col items-center justify-center min-h-[300px] gap-3 text-slate-400">
            <app-individual-toaster></app-individual-toaster>
            <p class="text-sm">Loading market details...</p>
        </div>
        } @else if (deepDiveError()) {
        <div class="p-6 flex flex-col items-center justify-center min-h-[300px] gap-3 text-red-500">
            <p class="text-sm">{{ deepDiveError() }}</p>
        </div>
        } @else if (deepDiveData()) {
        <!-- Body -->
        <div class="p-6">
            <!-- Hero Stats -->
            <div class="mb-6">
                <div class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2">
                    {{ (deepDiveData().isBizMode ? deepDiveData().activeBiz : deepDiveData().totalCon) | number }} {{
                    deepDiveData().isBizMode ? 'active businesses' : 'contracts' }}
                </div>
                <div class="text-[11.5px] leading-[1.45] text-slate-500 dark:text-slate-400">
                    {{ deepDiveData().segLabel }} · {{ (deepDiveData().isBizMode ? deepDiveData().totalCon :
                    deepDiveData().totalBiz) | number }} {{ deepDiveData().isBizMode ? 'contracts originated in ' +
                    deepDiveData().regionName : 'active businesses in ' + deepDiveData().regionName }}
                </div>
            </div>

            <!-- KPI Row -->
            <div class="grid grid-cols-4 gap-4 mb-6">
                <div
                    class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
                    <div class="text-[10px] font-bold text-[#6a7c93] uppercase tracking-wider mb-2">
                        {{ deepDiveData().isBizMode ? 'Total businesses' : 'Total contracts' }}
                    </div>
                    <div class="font-['Lato',sans-serif] text-[22px] font-normal leading-[1] tracking-[-0.5px] text-slate-900 dark:text-white">
                        {{ (deepDiveData().isBizMode ? deepDiveData().totalBiz : deepDiveData().totalCon) | number }}
                    </div>
                </div>
                <div
                    class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
                    <div class="text-[10px] font-bold text-[#6a7c93] uppercase tracking-wider mb-2">
                        {{ deepDiveData().isBizMode ? 'New · last 30 days' : 'Last 30 days' }}
                    </div>
                    <div class="font-['Lato',sans-serif] text-[22px] font-normal leading-[1] tracking-[-0.5px] text-slate-900 dark:text-white">
                        {{ deepDiveData().last30 | number }}
                    </div>
                </div>
                <div
                    class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
                    <div class="text-[10px] font-bold text-[#6a7c93] uppercase tracking-wider mb-2">
                        {{ deepDiveData().isBizMode ? 'New · last 7 days' : 'Last 7 days' }}
                    </div>
                    <div class="font-['Lato',sans-serif] text-[22px] font-normal leading-[1] tracking-[-0.5px] text-slate-900 dark:text-white">
                        {{ deepDiveData().last7 | number }}
                    </div>
                </div>
                <div
                    class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50">
                    <div class="text-[10px] font-bold text-[#6a7c93] uppercase tracking-wider mb-2">
                        {{ deepDiveData().isBizMode ? 'Avg contracts / biz' : 'Top-8 financed' }}
                    </div>
                    <div class="font-['Lato',sans-serif] text-[22px] font-normal leading-[1] tracking-[-0.5px] text-slate-900 dark:text-white">
                        {{ deepDiveData().isBizMode ? (deepDiveData().avgContracts | number:'1.1-1') : ('$' +
                        (deepDiveData().financedTotal/1000 | number:'1.0-0') + 'K') }}
                    </div>
                </div>
            </div>

            <!-- Sparkline section -->
            <div class="mb-8">
                <div class="text-[9.5px] font-[700] tracking-[0.7px] text-purple-700 uppercase mb-3">
                    {{ deepDiveData().isBizMode ? 'New businesses onboarded' : 'Contracts created' }}: last 30 days
                </div>
                <div
                    class="bg-slate-50 dark:bg-slate-900/50 rounded-xl p-4 border border-slate-100 dark:border-slate-700/50 flex flex-col">
                    <div class="w-full h-16 flex items-end justify-between gap-1 mb-3 relative">
                        <!-- SVG line chart for sparkline -->
                        <svg class="absolute inset-0 w-full h-full overflow-visible" viewBox="0 0 300 64"
                            preserveAspectRatio="none">
                            <defs>
                                <linearGradient id="sparkline-gradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#a855f7" stop-opacity="0.2"></stop>
                                    <stop offset="100%" stop-color="#a855f7" stop-opacity="0"></stop>
                                </linearGradient>
                            </defs>
                            <path [attr.d]="deepDiveData().sparklineArea" fill="url(#sparkline-gradient)"></path>
                            <path [attr.d]="deepDiveData().sparklinePath" fill="none" stroke="#a855f7" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"></path>
                            <circle [attr.cx]="300"
                                [attr.cy]="deepDiveData().peak > 0 ? 64 - (deepDiveData().sparklineData[29] / deepDiveData().peak * 64 * 0.9) : 64"
                                r="3" fill="#a855f7"></circle>
                        </svg>
                        <!-- Baseline line -->
                        <div class="absolute bottom-0 left-0 w-full h-[2px] bg-purple-500"></div>
                    </div>
                    <div class="flex items-center justify-between text-[11px] text-purple-700 dark:text-purple-400">
                        <span class="font-medium">30 DAYS · <b class="font-semibold">{{ deepDiveData().last30 | number
                                }}</b>
                            TOTAL</span>
                        <span class="font-medium">PEAK <b class="font-semibold">{{ deepDiveData().peak | number
                                }}</b>/DAY</span>
                        <span class="font-medium">AVG <b class="font-semibold">{{ (deepDiveData().last30/30) |
                                number:'1.1-1'
                                }}</b>/DAY</span>
                    </div>
                </div>
            </div>

            <!-- Table section -->
            <div>
                <div class="text-[9.5px] font-[700] tracking-[0.7px] text-purple-700 uppercase mb-3">
                    Top businesses by contract volume
                </div>
                <div class="overflow-x-auto">
                    <table class="w-full text-left border-collapse">
                        <thead>
                            <tr class="border-b border-slate-200 dark:border-slate-700">
                                <th
                                    class="py-3 px-3 text-[10.5px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide w-8">
                                    #</th>
                                <th class="py-3 px-3 text-[10.5px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
                                    Business</th>
                                <th class="py-3 px-3 text-[10.5px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide min-w-[105px]">
                                    Category</th>
                                <th class="py-3 px-3 text-[10.5px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide">
                                    Industry</th>
                                <th
                                    class="py-3 px-3 text-[10.5px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide text-right">
                                    Accounts</th>
                                <th
                                    class="py-3 px-3 text-[10.5px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide text-right">
                                    Contracts</th>
                                <th
                                    class="py-3 px-3 text-[10.5px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide text-right">
                                    Debt Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (biz of deepDiveData().topBusinesses; track biz.businessName; let i = $index) {
                            <tr
                                class="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-800/80 transition-colors">
                                <td class="py-3.5 px-3 text-[11px] text-slate-500 tabular-nums align-middle">{{ i + 1 }}</td>
                                <td class="py-3.5 px-3 text-[13px] font-normal text-slate-900 dark:text-white align-middle">{{
                                    biz.businessName }}</td>
                                <td class="py-3.5 px-3 align-middle">
                                    <span
                                        class="inline-flex items-center whitespace-nowrap px-2.5 py-1 rounded-full text-[10.5px] font-medium"
                                        [ngClass]="{
                              'bg-teal-50 text-teal-700 dark:bg-teal-500/10 dark:text-teal-400 border border-teal-200 dark:border-teal-800/50': biz.category === 'Dental',
                              'bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-400 border border-indigo-200 dark:border-indigo-800/50': biz.category === 'Healthcare',
                              'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400 border border-amber-200 dark:border-amber-800/50': biz.category === 'Non-Healthcare'
                            }">
                                        {{ biz.category }}
                                    </span>
                                </td>
                                <td class="py-3.5 px-3 align-middle">
                                    <span
                                        class="inline-flex items-center px-2.5 py-1 rounded-full text-[10.5px] font-medium bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">
                                        {{ biz.industry }}
                                    </span>
                                </td>
                                <td
                                    class="py-3.5 px-3 text-[12.5px] text-slate-700 dark:text-slate-300 tabular-nums text-right font-normal align-middle">
                                    {{
                                    biz.accounts | number }}</td>
                                <td
                                    class="py-3.5 px-3 text-[12.5px] text-slate-700 dark:text-slate-300 tabular-nums text-right font-normal align-middle">
                                    {{
                                    biz.total | number }}</td>
                                <td
                                    class="py-3.5 px-3 text-[12.5px] text-slate-700 dark:text-slate-300 tabular-nums text-right font-normal align-middle">
                                    ${{
                                    biz.financed_amount/1000 | number:'1.1-1' }}K</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        }
        </div>
    </div>
</div>
}